module.exports = __webpack_public_path__ + "static/media/checknoselected1.dfee0b44.png";